export const CONSULTATION_PAGE_BEFORE_LOADING = 'CONSULTATION_PAGE_BEFORE_LOADING';
